// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fix scrolling in MyProfile tabs */
.myprofile-tabs .ant-tabs-content-holder {
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1 1;
}

.myprofile-tabs .ant-tabs-content {
  height: 100%;
}

.myprofile-tabs .ant-tabs-tabpane {
  height: 100%;
}

/* ========== Dashboard Styles ========== */

.my-dashboard-container {
  padding: 20px 24px 40px;
}

/* Welcome Banner */
.dashboard-welcome-banner {
  background: linear-gradient(135deg, #0050b3 0%, #1890ff 50%, #36cfc9 100%);
  border-radius: 16px;
  padding: 24px 28px;
  margin-bottom: 20px;
  box-shadow: 0 8px 24px rgba(0, 80, 179, 0.25);
  position: relative;
  overflow: hidden;
}

.dashboard-welcome-banner::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
  border-radius: 50%;
}

.dashboard-welcome-banner::after {
  content: '';
  position: absolute;
  bottom: -30%;
  left: 10%;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%);
  border-radius: 50%;
}

.dashboard-welcome-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 1;
}

.dashboard-welcome-text h3 {
  font-weight: 700 !important;
  letter-spacing: -0.5px;
}

/* Main Layout Row */
.dashboard-main-row {
  min-height: 0;
}

/* ===== Left Panel: Links ===== */
.dashboard-links-panel {
  background: #fff;
  border-radius: 14px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  padding: 8px 0;
  height: 100%;
}

.dashboard-link-section {
  padding: 0 4px;
}

.dashboard-link-section + .dashboard-link-section {
  border-top: 1px solid #f0f0f0;
  margin-top: 4px;
  padding-top: 4px;
}

/* Today's Events Section */
.dashboard-today-section {
  max-height: 200px;
  overflow-y: auto;
}

.dashboard-today-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 6px 14px;
  margin: 0 4px;
  border-radius: 8px;
  transition: background 0.2s ease;
}

.dashboard-today-item:hover {
  background: #f0f5ff;
}

.dashboard-today-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 5px;
}

.dashboard-today-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1;
}

.dashboard-today-title {
  font-size: 12px;
  font-weight: 600;
  color: #262626;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dashboard-today-time {
  font-size: 11px;
  color: #8c8c8c;
  font-weight: 500;
}

.dashboard-link-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px 4px;
  color: #595959;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.dashboard-link-item {
  cursor: pointer;
  transition: background 0.2s ease;
  border-radius: 8px;
  margin: 0 4px;
}

.dashboard-link-item:hover {
  background: #f0f5ff;
}

.dashboard-link-item:active {
  background: #d6e4ff;
}

.dashboard-link-item-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 10px;
  position: relative;
}

.dashboard-link-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dashboard-link-title {
  font-size: 13px;
  font-weight: 500;
  color: #262626;
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dashboard-external-badge {
  font-size: 9px;
  font-weight: 700;
  color: #8c8c8c;
  background: #f5f5f5;
  padding: 1px 5px;
  border-radius: 4px;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}

/* ===== Modern Calendar ===== */
.mcal-panel {
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Header */
.mcal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  flex-wrap: wrap;
  gap: 12px;
}

.mcal-header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mcal-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.mcal-month-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
  min-width: 180px;
  text-align: center;
  letter-spacing: -0.3px;
}

.mcal-nav-btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid #e8e8e8;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #595959;
  font-size: 13px;
  transition: all 0.2s ease;
}

.mcal-nav-btn:hover {
  background: #f0f5ff;
  border-color: #1890ff;
  color: #1890ff;
  transform: scale(1.05);
}

.mcal-today-btn {
  padding: 6px 16px;
  border-radius: 8px;
  border: 1px solid #1890ff;
  background: #fff;
  color: #1890ff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mcal-today-btn:hover {
  background: #1890ff;
  color: #fff;
}

.mcal-legend {
  display: flex;
  gap: 12px;
}

.mcal-legend-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #8c8c8c;
  font-weight: 500;
}

.mcal-legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

/* Calendar Body */
.mcal-body {
  padding: 12px 16px 8px;
  flex: 1 1;
}

.mcal-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin-bottom: 4px;
}

.mcal-weekday {
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  color: #bfbfbf;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  padding: 8px 0;
}

.mcal-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

/* Cell */
.mcal-cell {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
  position: relative;
  min-height: 90px;
  padding: 4px;
  border: 1px solid transparent;
  overflow: hidden;
}

.mcal-cell:hover {
  background: #f0f5ff;
  border-color: #d6e4ff;
  z-index: 1;
}

.mcal-cell-outside {
  opacity: 0.3;
}

.mcal-cell-outside:hover {
  opacity: 0.6;
}

.mcal-date-num {
  font-size: 12px;
  font-weight: 600;
  color: #262626;
  line-height: 1;
  margin-bottom: 3px;
  text-align: right;
}

.mcal-cell-outside .mcal-date-num {
  color: #bfbfbf;
}

/* Today */
.mcal-cell-today {
  background: #e6f7ff;
}

.mcal-cell-today .mcal-date-num {
  color: #0050b3;
  font-weight: 800;
}

/* Selected */
.mcal-cell-selected {
  background: #e6f7ff !important;
  border-color: #1890ff !important;
}

.mcal-cell-selected .mcal-date-num {
  color: #1890ff !important;
  font-weight: 800;
}

/* Holiday cell */
.mcal-cell-holiday {
  background: #fff1f0;
}

.mcal-cell-holiday .mcal-date-num {
  color: #cf1322;
}

.mcal-cell-selected.mcal-cell-holiday {
  background: #fff1f0 !important;
  border-color: #f5222d !important;
}

/* Cell inline events */
.mcal-cell-events {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
  overflow: hidden;
}

.mcal-cell-evt {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 1px 3px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.03);
  overflow: hidden;
}

.mcal-cell-evt-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  flex-shrink: 0;
}

.mcal-cell-evt-text {
  font-size: 10px;
  color: #434343;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}

.mcal-cell-more {
  font-size: 9px;
  color: #8c8c8c;
  font-weight: 600;
  text-align: center;
  line-height: 1.3;
}

.mcal-cell-selected .mcal-cell-evt-text {
  color: #262626;
}

/* Events Panel */
.mcal-events-panel {
  border-top: 1px solid #f0f0f0;
  background: #fafbfc;
  max-height: 220px;
  overflow-y: auto;
}

.mcal-events-panel-header {
  padding: 12px 20px;
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #f0f0f0;
  position: sticky;
  top: 0;
  background: #fafbfc;
  z-index: 1;
}

.mcal-no-events {
  padding: 20px;
  text-align: center;
  color: #bfbfbf;
  font-size: 13px;
  font-style: italic;
}

.mcal-events-list {
  padding: 8px 12px;
}

.mcal-event-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  margin-bottom: 6px;
  background: #fff;
  border: 1px solid #f0f0f0;
  transition: all 0.2s ease;
  cursor: default;
}

.mcal-event-item:hover {
  border-color: var(--evt-color, #1890ff);
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  transform: translateX(4px);
}

.mcal-event-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.mcal-event-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1 1;
}

.mcal-event-title {
  font-size: 13px;
  font-weight: 600;
  color: #262626;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mcal-event-type {
  font-size: 11px;
  color: #8c8c8c;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
}

.mcal-event-time {
  color: #595959;
  font-weight: 600;
}

/* Responsive */
@media (max-width: 992px) {
  .dashboard-links-col {
    margin-bottom: 20px;
  }

  .dashboard-links-panel {
    display: flex;
    flex-wrap: wrap;
  }

  .dashboard-link-section {
    flex: 1 1;
    min-width: 200px;
  }

  .dashboard-link-section + .dashboard-link-section {
    border-top: none;
    border-left: 1px solid #f0f0f0;
    margin-top: 0;
    padding-top: 0;
  }
}

@media (max-width: 768px) {
  .my-dashboard-container {
    padding: 12px 12px 30px;
  }

  .dashboard-welcome-banner {
    padding: 18px;
    border-radius: 12px;
  }

  .dashboard-welcome-content {
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }

  .dashboard-links-panel {
    flex-direction: column;
  }

  .dashboard-link-section + .dashboard-link-section {
    border-left: none;
    border-top: 1px solid #f0f0f0;
    margin-top: 4px;
    padding-top: 4px;
  }

  .mcal-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 14px;
  }

  .mcal-header-right {
    width: 100%;
    justify-content: space-between;
  }

  .mcal-month-title {
    font-size: 16px;
    min-width: auto;
  }

  .mcal-cell {
    min-height: 70px;
    border-radius: 6px;
  }

  .mcal-date-num {
    font-size: 11px;
  }

  .mcal-cell-evt-text {
    font-size: 9px;
  }

  .mcal-legend {
    gap: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MyProfile/MyProfile.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,2CAA2C;;AAE3C;EACE,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,0EAA0E;EAC1E,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8EAA8E;EAC9E,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,aAAa;EACb,+EAA+E;EAC/E,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":["/* Fix scrolling in MyProfile tabs */\n.myprofile-tabs .ant-tabs-content-holder {\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n}\n\n.myprofile-tabs .ant-tabs-content {\n  height: 100%;\n}\n\n.myprofile-tabs .ant-tabs-tabpane {\n  height: 100%;\n}\n\n/* ========== Dashboard Styles ========== */\n\n.my-dashboard-container {\n  padding: 20px 24px 40px;\n}\n\n/* Welcome Banner */\n.dashboard-welcome-banner {\n  background: linear-gradient(135deg, #0050b3 0%, #1890ff 50%, #36cfc9 100%);\n  border-radius: 16px;\n  padding: 24px 28px;\n  margin-bottom: 20px;\n  box-shadow: 0 8px 24px rgba(0, 80, 179, 0.25);\n  position: relative;\n  overflow: hidden;\n}\n\n.dashboard-welcome-banner::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -20%;\n  width: 300px;\n  height: 300px;\n  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);\n  border-radius: 50%;\n}\n\n.dashboard-welcome-banner::after {\n  content: '';\n  position: absolute;\n  bottom: -30%;\n  left: 10%;\n  width: 200px;\n  height: 200px;\n  background: radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%);\n  border-radius: 50%;\n}\n\n.dashboard-welcome-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  z-index: 1;\n}\n\n.dashboard-welcome-text h3 {\n  font-weight: 700 !important;\n  letter-spacing: -0.5px;\n}\n\n/* Main Layout Row */\n.dashboard-main-row {\n  min-height: 0;\n}\n\n/* ===== Left Panel: Links ===== */\n.dashboard-links-panel {\n  background: #fff;\n  border-radius: 14px;\n  border: 1px solid #f0f0f0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  padding: 8px 0;\n  height: 100%;\n}\n\n.dashboard-link-section {\n  padding: 0 4px;\n}\n\n.dashboard-link-section + .dashboard-link-section {\n  border-top: 1px solid #f0f0f0;\n  margin-top: 4px;\n  padding-top: 4px;\n}\n\n/* Today's Events Section */\n.dashboard-today-section {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.dashboard-today-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 6px 14px;\n  margin: 0 4px;\n  border-radius: 8px;\n  transition: background 0.2s ease;\n}\n\n.dashboard-today-item:hover {\n  background: #f0f5ff;\n}\n\n.dashboard-today-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-top: 5px;\n}\n\n.dashboard-today-info {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n}\n\n.dashboard-today-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #262626;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dashboard-today-time {\n  font-size: 11px;\n  color: #8c8c8c;\n  font-weight: 500;\n}\n\n.dashboard-link-section-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 14px 4px;\n  color: #595959;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n}\n\n.dashboard-link-item {\n  cursor: pointer;\n  transition: background 0.2s ease;\n  border-radius: 8px;\n  margin: 0 4px;\n}\n\n.dashboard-link-item:hover {\n  background: #f0f5ff;\n}\n\n.dashboard-link-item:active {\n  background: #d6e4ff;\n}\n\n.dashboard-link-item-inner {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 10px;\n  position: relative;\n}\n\n.dashboard-link-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.dashboard-link-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: #262626;\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dashboard-external-badge {\n  font-size: 9px;\n  font-weight: 700;\n  color: #8c8c8c;\n  background: #f5f5f5;\n  padding: 1px 5px;\n  border-radius: 4px;\n  letter-spacing: 0.5px;\n  flex-shrink: 0;\n}\n\n/* ===== Modern Calendar ===== */\n.mcal-panel {\n  background: #fff;\n  border-radius: 16px;\n  border: 1px solid #e8e8e8;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Header */\n.mcal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f0f0f0;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.mcal-header-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mcal-header-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.mcal-month-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin: 0;\n  min-width: 180px;\n  text-align: center;\n  letter-spacing: -0.3px;\n}\n\n.mcal-nav-btn {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  border: 1px solid #e8e8e8;\n  background: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #595959;\n  font-size: 13px;\n  transition: all 0.2s ease;\n}\n\n.mcal-nav-btn:hover {\n  background: #f0f5ff;\n  border-color: #1890ff;\n  color: #1890ff;\n  transform: scale(1.05);\n}\n\n.mcal-today-btn {\n  padding: 6px 16px;\n  border-radius: 8px;\n  border: 1px solid #1890ff;\n  background: #fff;\n  color: #1890ff;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.mcal-today-btn:hover {\n  background: #1890ff;\n  color: #fff;\n}\n\n.mcal-legend {\n  display: flex;\n  gap: 12px;\n}\n\n.mcal-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  color: #8c8c8c;\n  font-weight: 500;\n}\n\n.mcal-legend-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n/* Calendar Body */\n.mcal-body {\n  padding: 12px 16px 8px;\n  flex: 1;\n}\n\n.mcal-weekdays {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  margin-bottom: 4px;\n}\n\n.mcal-weekday {\n  text-align: center;\n  font-size: 11px;\n  font-weight: 700;\n  color: #bfbfbf;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  padding: 8px 0;\n}\n\n.mcal-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n\n/* Cell */\n.mcal-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n  position: relative;\n  min-height: 90px;\n  padding: 4px;\n  border: 1px solid transparent;\n  overflow: hidden;\n}\n\n.mcal-cell:hover {\n  background: #f0f5ff;\n  border-color: #d6e4ff;\n  z-index: 1;\n}\n\n.mcal-cell-outside {\n  opacity: 0.3;\n}\n\n.mcal-cell-outside:hover {\n  opacity: 0.6;\n}\n\n.mcal-date-num {\n  font-size: 12px;\n  font-weight: 600;\n  color: #262626;\n  line-height: 1;\n  margin-bottom: 3px;\n  text-align: right;\n}\n\n.mcal-cell-outside .mcal-date-num {\n  color: #bfbfbf;\n}\n\n/* Today */\n.mcal-cell-today {\n  background: #e6f7ff;\n}\n\n.mcal-cell-today .mcal-date-num {\n  color: #0050b3;\n  font-weight: 800;\n}\n\n/* Selected */\n.mcal-cell-selected {\n  background: #e6f7ff !important;\n  border-color: #1890ff !important;\n}\n\n.mcal-cell-selected .mcal-date-num {\n  color: #1890ff !important;\n  font-weight: 800;\n}\n\n/* Holiday cell */\n.mcal-cell-holiday {\n  background: #fff1f0;\n}\n\n.mcal-cell-holiday .mcal-date-num {\n  color: #cf1322;\n}\n\n.mcal-cell-selected.mcal-cell-holiday {\n  background: #fff1f0 !important;\n  border-color: #f5222d !important;\n}\n\n/* Cell inline events */\n.mcal-cell-events {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  overflow: hidden;\n}\n\n.mcal-cell-evt {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 1px 3px;\n  border-radius: 3px;\n  background: rgba(0, 0, 0, 0.03);\n  overflow: hidden;\n}\n\n.mcal-cell-evt-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.mcal-cell-evt-text {\n  font-size: 10px;\n  color: #434343;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.4;\n}\n\n.mcal-cell-more {\n  font-size: 9px;\n  color: #8c8c8c;\n  font-weight: 600;\n  text-align: center;\n  line-height: 1.3;\n}\n\n.mcal-cell-selected .mcal-cell-evt-text {\n  color: #262626;\n}\n\n/* Events Panel */\n.mcal-events-panel {\n  border-top: 1px solid #f0f0f0;\n  background: #fafbfc;\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.mcal-events-panel-header {\n  padding: 12px 20px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1a1a2e;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  border-bottom: 1px solid #f0f0f0;\n  position: sticky;\n  top: 0;\n  background: #fafbfc;\n  z-index: 1;\n}\n\n.mcal-no-events {\n  padding: 20px;\n  text-align: center;\n  color: #bfbfbf;\n  font-size: 13px;\n  font-style: italic;\n}\n\n.mcal-events-list {\n  padding: 8px 12px;\n}\n\n.mcal-event-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  margin-bottom: 6px;\n  background: #fff;\n  border: 1px solid #f0f0f0;\n  transition: all 0.2s ease;\n  cursor: default;\n}\n\n.mcal-event-item:hover {\n  border-color: var(--evt-color, #1890ff);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\n  transform: translateX(4px);\n}\n\n.mcal-event-icon {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.mcal-event-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n  flex: 1;\n}\n\n.mcal-event-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #262626;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mcal-event-type {\n  font-size: 11px;\n  color: #8c8c8c;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.mcal-event-time {\n  color: #595959;\n  font-weight: 600;\n}\n\n/* Responsive */\n@media (max-width: 992px) {\n  .dashboard-links-col {\n    margin-bottom: 20px;\n  }\n\n  .dashboard-links-panel {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .dashboard-link-section {\n    flex: 1;\n    min-width: 200px;\n  }\n\n  .dashboard-link-section + .dashboard-link-section {\n    border-top: none;\n    border-left: 1px solid #f0f0f0;\n    margin-top: 0;\n    padding-top: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .my-dashboard-container {\n    padding: 12px 12px 30px;\n  }\n\n  .dashboard-welcome-banner {\n    padding: 18px;\n    border-radius: 12px;\n  }\n\n  .dashboard-welcome-content {\n    flex-direction: column;\n    text-align: center;\n    gap: 12px;\n  }\n\n  .dashboard-links-panel {\n    flex-direction: column;\n  }\n\n  .dashboard-link-section + .dashboard-link-section {\n    border-left: none;\n    border-top: 1px solid #f0f0f0;\n    margin-top: 4px;\n    padding-top: 4px;\n  }\n\n  .mcal-header {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 12px 14px;\n  }\n\n  .mcal-header-right {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .mcal-month-title {\n    font-size: 16px;\n    min-width: auto;\n  }\n\n  .mcal-cell {\n    min-height: 70px;\n    border-radius: 6px;\n  }\n\n  .mcal-date-num {\n    font-size: 11px;\n  }\n\n  .mcal-cell-evt-text {\n    font-size: 9px;\n  }\n\n  .mcal-legend {\n    gap: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
